export const geoVersion = (route, geo, lang) => {
    let originalRouteParams = route.params || {};

    let routeCopy = { ...route };
    const path = routeCopy.path;

    delete routeCopy.path;

    return Object.assign({}, routeCopy, {
        path,
        params: {
            ...originalRouteParams,
            geo: geo,
            lang: lang,
        },
    });
};

export default {
    install(Vue) {
        Vue.prototype.$linkwrap = function(route) {
            return geoVersion(route, this.$route.params.geo, this.$route.params.lang);
        };
    },
};
